import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ApiServiceService } from '../../services/common/api-service.service';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-merchant-login',
  templateUrl: './merchant-login.component.html',
  styleUrls: ['./merchant-login.component.scss'],
})
export class MerchantLoginComponent implements OnInit, OnDestroy {

  merchantLoginForm!: FormGroup;

  forgotPasswordForm!: FormGroup;

  hidePassword = true;

  showForgotPassword = false;

  forgotPasswordStep: 'email' | 'otp' = 'email';

  forgotPasswordLoading = false;

  forgotPasswordMessage =
    'Enter your registered email address and we will send you a one-time OTP.';

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiServiceService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.merchantLoginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],

      password: ['', Validators.required],
    });
    this.forgotPasswordForm = this.formBuilder.group({

  forgotEmail: ['', [Validators.required, Validators.email]],

  forgotOtp: ['', [Validators.required, Validators.minLength(6)]],

  forgotPassword: ['', [Validators.required, Validators.minLength(6)]]

});
  }

  ngOnInit(): void {
    this.document.body.classList.add('auth-page-body');
  }

  ngOnDestroy(): void {
    this.document.body.classList.remove('auth-page-body');
  }

  togglePassword() {
    this.hidePassword = !this.hidePassword;
  }
  openForgotPassword(): void {

  this.showForgotPassword = true;

  this.forgotPasswordStep = 'email';

  this.forgotPasswordLoading = false;

  this.forgotPasswordForm.reset();

}



closeForgotPassword(): void {

  this.showForgotPassword = false;

  this.forgotPasswordStep = 'email';

  this.forgotPasswordLoading = false;

  this.forgotPasswordForm.reset();

}



requestForgotPasswordOtp(): void {

  const email =
    this.forgotPasswordForm.get('forgotEmail')?.value;


  this.apiService.merchantForgotPassword(email)
  .subscribe({

    next:(response)=>{

      this.forgotPasswordStep = 'otp';


      Swal.fire({

        title:'OTP Sent',

        text:'OTP sent to your email',

        icon:'success',

        confirmButtonColor:'#a73453'

      });

    },

    error:(error)=>{

      Swal.fire({

        title:'Reset Failed',

        text:error?.error?.data || 'Unable to send OTP',

        icon:'error',

        confirmButtonColor:'#a73453'

      });

    }

  });

}



resetPasswordWithOtp(): void {


  const email =
  this.forgotPasswordForm.get('forgotEmail')?.value;


  const otp =
  this.forgotPasswordForm.get('forgotOtp')?.value;


  const password =
  this.forgotPasswordForm.get('forgotPassword')?.value;



  this.apiService.merchantResetPassword(
    email,
    otp,
    password
)
  .subscribe({

    next:(response)=>{

      Swal.fire({

        title:'Password Updated',

        text:'Password changed successfully',

        icon:'success',

        confirmButtonColor:'#a73453'

      });


      this.closeForgotPassword();

    },

    error:(error)=>{

      Swal.fire({

        title:'Reset Failed',

        text:error?.error?.data || 'Unable to reset password',

        icon:'error',

        confirmButtonColor:'#a73453'

      });

    }

  });

}
  onSubmit() {
    if (this.merchantLoginForm.invalid) {
      this.merchantLoginForm.markAllAsTouched();
      return;
    }

    const email = this.merchantLoginForm.value.email;

    const password = this.merchantLoginForm.value.password;

    this.apiService.merchantLogin(email, password).subscribe({
      next: (response) => {
        console.log('Merchant Login Response', response);

        if (response.status === 'success') {
          localStorage.setItem('merchantToken', response.data.sessionToken);

          localStorage.setItem('merchantId', response.data.merchantId);

          localStorage.setItem('merchantName', response.data.business_name);

          Swal.fire({
            title: 'Login Successful',

            text: 'Welcome ' + response.data.business_name,

            icon: 'success',

            timer: 1500,

            showConfirmButton: false,
          });

          // future merchant dashboard

          this.router.navigate(['/merchant/dashboard'])
        } else {
          const errorText = typeof response.data === 'string' ? response.data : (response.message || 'Invalid Email or Password');
          Swal.fire({
            title: 'Login Failed',
            text: errorText,
            icon: 'error',
            confirmButtonColor: '#a73453',
          });
        }
      },
      error: (error) => {
        console.log(error);
        const errorText =
          (typeof error?.error?.data === 'string' && error.error.data) ||
          error?.error?.message ||
          (typeof error?.error === 'string' && error.error) ||
          error?.message ||
          'Invalid Email or Password';
        Swal.fire({
          title: 'Login Failed',
          text: errorText,
          icon: 'error',
          confirmButtonColor: '#a73453',
        });
      },
    });
  }
}
